var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center",
    "data-name": "01 align center",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49086",
    "data-name": "Path 49086",
    d: "M17,3H13.25V1.5A1.5,1.5,0,0,0,11.75,0H7.25a1.5,1.5,0,0,0-1.5,1.5V3H2V4.5H3.5V15.75A2.25,2.25,0,0,0,5.75,18h7.5a2.25,2.25,0,0,0,2.25-2.25V4.5H17ZM7.25,1.5h4.5V3H7.25ZM14,15.75a.75.75,0,0,1-.75.75H5.75A.75.75,0,0,1,5,15.75V4.5h9Z",
    transform: "translate(0 0)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20785",
    "data-name": "Rectangle 20785",
    width: 1.5,
    height: 6,
    transform: "translate(7.25 7.5)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20786",
    "data-name": "Rectangle 20786",
    width: 1.5,
    height: 6,
    transform: "translate(10.25 7.5)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.be3c13434f81893bcd2e6afba6cf279f.svg";
export { ForwardRef as ReactComponent };